import React, { useState } from "react";

const TruncatedText = ({ text, limit = 100 }) => {
    const [expanded, setExpanded] = useState(false);

    if (!text) return null;

    const isLongText = text.length > limit;
    const displayText = expanded ? text : text.substring(0, limit);

    return (
        <p className="text-gray-800">
            {displayText}
            {isLongText && (
                <span
                    onClick={() => setExpanded(!expanded)}
                    className="text-blue-600 cursor-pointer ml-2 font-medium"
                >
                    {expanded ? "See Less" : "See More"}
                </span>
            )}
        </p>
    );
};

export default TruncatedText;
